import { useAtom } from '@reatom/npm-react'

import { userAtom } from '@root/entities/auth'
import { UserAvatar } from '@root/entities/auth/ui'
import { UserShort } from '@root/entities/user-short'
import { UserShortAvatar } from '@root/entities/user-short/ui/user-short-avatar'
import { useAppRoutes } from '@root/features/routing'

import { FollowUserButton } from '../../activity-actions'
import { ActivityKebabActions } from '../../activity-actions/activity-kebab-actions'

import { UserConnectionsItem } from './user-connections-item/user-connections-item'

import type { FollowerDetail } from '@root/entities/follower-detail'

interface UserConnectionsFollowingProps {
  following: FollowerDetail.FollowerDetail
}

export const UserConnectionsFollowing = ({
  following,
}: UserConnectionsFollowingProps) => {
  const { navigateUserProfile } = useAppRoutes()

  const [user] = useAtom(userAtom)
  const isAuthor = following.delugeId === user?.delugeId
  const showName = isAuthor
    ? UserShort.someName(user)
    : UserShort.someName(following)

  const handleNavigateToUserProfile = () =>
    navigateUserProfile(following.delugeId)

  return (
    <UserConnectionsItem
      avatar={
        isAuthor ? (
          <UserAvatar withPreview size={24} />
        ) : (
          <UserShortAvatar withPreview size={24} userShort={following} />
        )
      }
      followers={following.followersCount}
      following={following.followingCount}
      coins={following.deployedTokensCount}
      name={showName}
      key={following.delugeId}
      delugeId={following.delugeId}
    >
      <FollowUserButton
        delugeId={following.delugeId}
        variant="soft"
        size="xs"
        radius="rounded"
        type="button"
      />
      <ActivityKebabActions
        userShort={following}
        onNavigateToUserProfile={handleNavigateToUserProfile}
      />
    </UserConnectionsItem>
  )
}
